import { IDropdownOption } from "components/atoms";
import { useCourseSessions } from "./useCourseSessions";
import { CourseSessionApi } from "api/courseSessionsApi";

export interface CourseSessionOption extends IDropdownOption {
  session: CourseSessionApi;
}

export const useCourseSessionsOptions = (courseId?: string | number) => {
  const { loading, data } = useCourseSessions(courseId);

  const options: CourseSessionOption[] = data?.map((x) => ({
    value: x.id.toString(),
    label: x.name,
    session: x,
  }));

  return { loading, options };
};
